import { Loader } from "common"
import React, { useEffect, useState } from "react";
import { useUser } from "hooks/user/user";
import { useProfileStore } from "store";
import { useAuth } from "hooks";
import { RouteName, routeNames } from "utils";
import { useApolloAuth } from "providers/apollo_auth";

export const AuthGuard:React.FC<{
    children: React.ReactNode;
    loginRoute: RouteName;
}> = ({ children, loginRoute }) => {
    const [loading, setLoading] = useState(false);
    const { loaded, accessToken } = useApolloAuth();
    const userHook = useUser();
    const { setUser } = useProfileStore();
    const authHook = useAuth();
    useEffect(() => {
        if(loaded){
            if(accessToken){
                setLoading(true);
                userHook.me().then(response => {
                    if(response?.user){
                        setUser(response?.user)
                    }else {
                        authHook.logout(routeNames[loginRoute]);
                    }
                }).finally(() => setLoading(false))
            }else {
                authHook.logout(routeNames[loginRoute]);
            }
        }
    }, [loaded, accessToken])

    if(loading){
        return <Loader/>
    }

    return <>{children}</>
}

export default AuthGuard